import { render, staticRenderFns } from "./VisitorMediaAndDocuments.vue?vue&type=template&id=470db3b2&scoped=true"
import script from "./VisitorMediaAndDocuments.vue?vue&type=script&lang=js"
export * from "./VisitorMediaAndDocuments.vue?vue&type=script&lang=js"
import style0 from "./VisitorMediaAndDocuments.vue?vue&type=style&index=0&id=470db3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470db3b2",
  null
  
)

export default component.exports